import React from 'react'
import { isMobile } from 'react-device-detect'
import { Provider } from 'react-redux'

import RouterPage from './RouterPage'
import configureStore from './store/configureStore'
import { Marketplace } from './containers'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './configs'

const store = configureStore()
const VALID_PATH = new RegExp(/\/reset_password|set_password\/[A-Za-z0-9]+/g)


function StartPage() {
  const pathname = window.location.pathname
  const validPathName = VALID_PATH.test(pathname)

  const msalInstance = new PublicClientApplication(msalConfig);

  return (
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        {isMobile && !validPathName ? <Marketplace /> : <RouterPage />}
      </MsalProvider>
    </Provider>
  )
}

export default StartPage
